import localizationData from "./en.json";
import localized from "model/events/util";

const events = (context, setEvent) =>
  [
    {
      title: "event.promotion.ranchHand.title",
      description: "event.promotion.ranchHand.description",
      effect: {
        resources: { health: 5 },
        traits: { resilience: 1 },
      },
      buttons: [
        {
          title: "event.promotion.ranchHand.button.accept",
          message: "event.promotion.ranchHand.button.message.accept",
          effect: {
            resources: { health: 5 },
            traits: { resilience: 2 },
          },
        },
        {
          title: "event.promotion.ranchHand.button.decline",
          message: "event.promotion.ranchHand.button.message.decline",
          isDimsiss: true,
        },
      ],
    },
    {
      title: "event.promotion.outrider.title",
      description: "event.promotion.outrider.description",
      effect: {
        resources: { morale: 5 },
        traits: { stealth: 1 },
      },
      buttons: [
        {
          title: "event.promotion.outrider.button.accept",
          message: "event.promotion.outrider.button.message.accept",
          effect: {
            resources: { morale: 5 },
            traits: { stealth: 5 },
          },
        },
        {
          title: "event.promotion.outrider.button.decline",
          message: "event.promotion.outrider.button.message.decline",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.promotion.herder.title",
      description: "event.promotion.herder.description",
      effect: {
        resources: { food: 5 },
        traits: { resilience: 1 },
      },
      buttons: [
        {
          title: "event.promotion.herder.button.accept",
          message: "event.promotion.herder.button.message.accept",
          effect: {
            resources: { food: 5 },
            traits: { resilience: 1 },
          },
        },
        {
          title: "event.promotion.herder.button.decline",
          message: "event.promotion.herder.button.message.decline",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.promotion.horseWrangler.title",
      description: "event.promotion.horseWrangler.description",
      effect: {
        resources: { morale: 5 },
        traits: { charisma: 1 },
      },
      buttons: [
        {
          title: "event.promotion.horseWrangler.button.accept",
          message: "event.promotion.horseWrangler.button.message.accept",
          effect: {
            resources: { morale: 5 },
            traits: { charisma: 1 },
          },
        },
        {
          title: "event.promotion.horseWrangler.button.decline",
          message: "event.promotion.horseWrangler.button.message.decline",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.promotion.fenceRider.title",
      description: "event.promotion.fenceRider.description",
      effect: {
        resources: { ammo: 5 },
        traits: { luck: 1 },
      },
      buttons: [
        {
          title: "event.promotion.fenceRider.button.accept",
          message: "event.promotion.fenceRider.button.message.accept",
          effect: {
            resources: { ammo: 30 },
            traits: { luck: 2 },
          },
        },
        {
          title: "event.promotion.fenceRider.button.decline",
          message: "event.promotion.fenceRider.button.message.decline",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.promotion.chuckWranglerAssistant.title",
      description: "event.promotion.chuckWranglerAssistant.description",
      effect: {
        resources: { food: 5 },
        traits: { haggling: 1 },
      },
      buttons: [
        {
          title: "event.promotion.chuckWranglerAssistant.button.accept",
          message:
            "event.promotion.chuckWranglerAssistant.button.message.accept",
          effect: {
            resources: { food: 10 },
            traits: { haggline: 2 },
          },
        },
        {
          title: "event.promotion.chuckWranglerAssistant.button.decline",
          message:
            "event.promotion.chuckWranglerAssistant.button.message.decline",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.promotion.branderAssistant.title",
      description: "event.promotion.branderAssistant.description",
      effect: {
        resources: { morale: 5 },
        traits: { resilience: 1 },
      },
      buttons: [
        {
          title: "event.promotion.branderAssistant.button.accept",
          message: "event.promotion.branderAssistant.button.message.accept",
          effect: {
            resources: { morale: 10 },
            traits: { resilience: 2 },
          },
        },
        {
          title: "event.promotion.branderAssistant.button.decline",
          message: "event.promotion.branderAssistant.button.message.decline",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.promotion.trailHand.title",
      description: "event.promotion.trailHand.description",
      effect: {
        resources: { water: 5 },
        traits: { luck: 5 },
      },
      buttons: [
        {
          title: "event.promotion.trailHand.button.accept",
          message: "event.promotion.trailHand.button.message.accept",
          effect: {
            resources: { food: 10, coins: 10 },
            traits: { charisma: 2 },
          },
        },
        {
          title: "event.promotion.trailHand.button.decline",
          message: "event.promotion.trailHand.button.message.decline",
          isDismiss: true,
        },
      ],
    },
    {
      title: "event.promotion.foreman.title",
      description: "event.promotion.foreman.description",
      effect: {
        resources: { coins: 10 },
        traits: { charisma: 5, resilience: 15 },
      },
      buttons: [
        {
          title: "event.promotion.foreman.button.accept",
          message: "event.promotion.foreman.button.message.accept",
          effect: {
            resources: { food: 50, coins: 50 },
            traits: { charisma: 2 },
          },
        },
        {
          title: "event.promotion.foreman.button.decline",
          message: "event.promotion.foreman.button.message.decline",
          isDismiss: true,
        },
      ],
    },
  ].map((event) => localized(event, localizationData));

export default events;
